import React from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import hexagon_background from 'images/hexagon_background.svg'
import styles from './styles'
import theme from 'theme'

const useStyles = makeStyles(() => styles(theme))

const HexagonStructure = ({ children, ...rest }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root} {...rest}>
      {children}
    </Box>
  )
}

export default HexagonStructure
